import { ApiService } from "./../../../shared/services/api/api.service";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router, RouterModule } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";

import { GloButtonComponent } from "../../../shared/components/glo-button/glo-button.component";
import { ForgotPasswordComponent } from "../forgot-password/forgot-password.component";
import { LoaderComponent } from "../../../shared/components/loader/loader.component";
import { API_ENDPOINTS } from "../../../shared/services/api/api-endpoints";
import { environment } from "../../../../environments/environment";
import { LogoHeaderComponent } from "../../../shared/components/logo-header/logo-header.component";

@Component({
  selector: "customer-login",
  standalone: true,
  imports: [
    RouterModule,
    GloButtonComponent,
    FormsModule,
    CommonModule,
    LoaderComponent,
    LogoHeaderComponent,
  ],
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class CustomerLoginComponent implements OnChanges {
  private dialog = inject(MatDialog);
  private router = inject(Router);

  assetUrl = environment.assetBaseUrl;

  @Input() LoginFromModal = false;
  @Input() initialEmail = "";

  @Output() isLoggedIn = new EventEmitter<void>();
  @Output() handleRegisterUser = new EventEmitter<void>();

  @Output() otpRequested = new EventEmitter<string>();
  @Output() registerRequested = new EventEmitter<string>();

  isLoading = false;
  email = "";
  password = "";
  errorMessage = "";
  passwordVisible = false;

  constructor(private ApiService: ApiService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["initialEmail"] && this.initialEmail && !this.email) {
      this.email = this.initialEmail;
    }
  }

  openForgotPasswordModal(): void {
    this.dialog.open(ForgotPasswordComponent, {
      width: "calc(100% - 32px)",
      maxWidth: "460px",
      disableClose: false,
      autoFocus: true,
      data: {
        email: this.email.trim(),
      },
    });
  }

  onSubmit(): void {
    const email = this.email.trim();

    if (!email || !this.password) {
      this.errorMessage = "Email and password are required!";
      return;
    }

    const loginData = {
      email,
      password: this.password,
    };

    this.isLoading = true;
    this.errorMessage = "";

    this.ApiService.request(
      API_ENDPOINTS.auth.requestOtp,
      "POST",
      loginData,
      "Verification code sent to your email!",
      undefined,
      { skipAuth: true },
    ).subscribe({
      next: (response: any) => {
        console.log("Verification code sent successfully:", response);

        this.isLoading = false;
        this.errorMessage = "";

        const otpEmail = response?.email || email;

        if (this.LoginFromModal) {
          this.otpRequested.emit(otpEmail);
          return;
        }

        sessionStorage.setItem("otp_email", otpEmail);
        this.router.navigateByUrl("/verify-otp");
      },

      error: (err) => {
        console.error("Login failed:", err);
        this.isLoading = false;

        if (err.error?.detail) {
          this.errorMessage = err.error.detail;
        } else {
          this.errorMessage = "Login failed. Please check your credentials.";
        }
      },
    });
  }

  requestRegistration(): void {
    if (this.LoginFromModal) {
      this.registerRequested.emit(this.email.trim());
      return;
    }

    this.handleRegisterUser.emit();
  }

  toggleVisibility(): void {
    this.passwordVisible = !this.passwordVisible;
  }
}
